/** Get a short-lived URL to Stripe's billing portal. */
export const tenantBillingPortalLinkSpec = {
    uri: '/t/[tenant]/billing/portal-link',
    method: 'GET',
};
